<template>
  <div class="error">
    <div class="img">
      <span>404!</span>
    </div>
    <h1>找不到页面了~</h1>
    <router-link to="/"><Button type="info">返回首页</Button></router-link>
  </div>
</template>
<script>
export default {

};
</script>
<style lang="less" scoped>
.error {
  text-align: center;
  margin: 8% 0;
  a.primary {
    display: inline-block;
    padding: 6px 25px;
    box-sizing: border-box;
    transition: all .1s linear;
    cursor: pointer;
    color: #fff;
    background: #487AFF;
    &:hover {
        background: #1662e7;
    }
    &:disabled {
        color: #ACACAF;
        cursor:not-allowed;
        background: #2A3B90;
    }
  }
  .img {
    width: 249.2px;  // 623*0.4
    height: 190px; // 475*0.4
    background: url('../assets/img/error.png') no-repeat;
    background-size: cover;
    margin: 0 auto;
    text-align: center;
    padding-top: 58px;
    span {
      color: #FF8748;
      font-size: 50px;
    }
  }
  h1 {
    margin: 20px 0;
    font-size: 20px;
    color: #4A7AFD;
  }
}
</style>